'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isNull = require('lodash/isNull');

var _isNull2 = _interopRequireDefault(_isNull);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _DebugManager = require('../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _RUMUtil = require('../utils/RUMUtil');

var _RUMUtil2 = _interopRequireDefault(_RUMUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dmInstance = _DebugManager2.default.dmInstance;

var MAX_CONNECTION_CHECKS = 60;

var WSEvent = function () {
  function WSEvent(dataHandler, errorHandler) {
    var _this = this;

    _classCallCheck(this, WSEvent);

    this.event = function (event) {
      var _JSON$parse = JSON.parse(event.data),
          id = _JSON$parse.id,
          serverError = _JSON$parse.serverError,
          _JSON$parse$component = _JSON$parse.componentEvent;

      _JSON$parse$component = _JSON$parse$component === undefined ? {} : _JSON$parse$component;
      var compEventId = _JSON$parse$component.id,
          payload = _JSON$parse$component.payload;


      if (!(0, _isUndefined2.default)(serverError)) {
        console.warn('[WsEvent] WS post failed:');
        var error = new Error('[WsEvent] WS post failed');
        _RUMUtil2.default.addError(error, { serverError: serverError });
        return;
      }

      _this.dataHandler([{ payload: payload }]);
      dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Processed component event: ' + compEventId);
      dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Last component event processed: ' + id);
      _this.lastEventProcessed = id;
      _this.unprocessedEvents.delete(compEventId);
    };

    this.error = function (event) {
      var msg = '[WsEvent] Error from websocket';
      console.error(msg, event);
      _this.errorHandler(event, msg);
    };

    this.close = function () {
      var closeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // We have seen the case where the websocket just closes without firing the error handler,
      // so we need to log the code and reason to decipher what happened.
      var socketReadyState = _this.socket ? _this.socket.readyState : '';
      var msg = '[WsEvent] Websocket closed with code: (' + closeEvent.code + ') reason: ' + closeEvent.reason + ', readyState: ' + socketReadyState;
      console.warn(msg);
      var eventData = _this.getLastUnprocessedEventData();
      _this.errorHandler(eventData && JSON.parse(eventData), msg);
    };

    this.cleanup = function () {
      if (_this.socket && _this.socket.readyState === 1) {
        _this.socket.close();
        console.warn('[WsEvent] Socket successfully closed');
      }
      _this.socket = null;
      _this.checkConnectionCleanup();
    };

    this.postEvent = function (metadata, data) {
      var inBand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var componentEventId = _this.reluctantlyGenerateUniqueId();
      dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Received new event ' + componentEventId, data);

      // users can potentially start performing actions in the control room before the socket has connected,
      // so we need a check for a connected and open socket
      if (!_this.isConnectionReady()) {
        dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Connection not fully established yet. Adding ' + componentEventId + ' to queue.');
        _this.unprocessedEvents.set(componentEventId, { metadata: metadata, data: data, inBand: inBand });

        if (!_this.checkConnectionInterval) {
          _this.checkConnectionInterval = setInterval(_this.checkConnection, 1000);
        }
        return;
      }

      _this.unprocessedEvents.set(componentEventId, { metadata: metadata, data: data, inBand: inBand });
      var postObj = _this.generatePostData(componentEventId, metadata, data, inBand);
      if (postObj) {
        _this.send(postObj);
      }
    };

    this.isConnectionReady = function () {
      return !(0, _isNull2.default)(_this.socket) && _this.socket.readyState === 1;
    };

    this.checkConnection = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.numOfChecks++;

              if (_this.isConnectionReady()) {
                _context.next = 5;
                break;
              }

              if (_this.numOfChecks > MAX_CONNECTION_CHECKS) {
                dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Exceeded time limit to process events via websocket.');
                msg = '[WsEvent] Could not process received events via websocket.';

                _this.errorHandler({ metadata: metadata, data: data }, msg);
              }
              _context.next = 8;
              break;

            case 5:
              _this.checkConnectionCleanup();
              _context.next = 8;
              return _this.handleUnprocessedEvents();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    this.processUnprocessedEvents = function () {
      return new Promise(function (resolve) {
        [].concat(_toConsumableArray(_this.unprocessedEvents)).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              _ref3$ = _ref3[1],
              metadata = _ref3$.metadata,
              data = _ref3$.data,
              inBand = _ref3$.inBand;

          dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Processing unprocessed component event via websocket: id: ' + key + ' data: ' + data);
          var postObj = _this.generatePostData(key, metadata, data, inBand);
          if (postObj) {
            _this.send(postObj);
          }
        });
        resolve();
      });
    };

    this.getUnprocessedEvents = function () {
      return _this.unprocessedEvents;
    };

    this.emptyUnprocessedEvents = function () {
      _this.unprocessedEvents = new Map();
    };

    this.getLastUnprocessedEventData = function () {
      var lastEvent = [].concat(_toConsumableArray(_this.unprocessedEvents))[_this.unprocessedEvents.size - 1];

      var _ref4 = lastEvent ? lastEvent[1] : {},
          data = _ref4.data;

      return data;
    };

    this.getLastEventProcessed = function () {
      return _this.lastEventProcessed;
    };

    this.reluctantlyGenerateUniqueId = function () {
      return Date.now() + '-' + Math.floor(Math.random() * 100000);
    };

    this.socket = null;
    this.dataHandler = dataHandler || this.missingHandler;
    this.errorHandler = errorHandler || this.missingHandler;
    this.unprocessedEvents = new Map();
    this.lastEventProcessed = '';
    this.numOfChecks = 0;
  }

  _createClass(WSEvent, [{
    key: 'missingHandler',
    value: function missingHandler() {
      throw new Error('Missing handler function!');
    }
  }, {
    key: 'initiate',
    value: function initiate(accountId, eventId, wsComponentEventHost) {
      var _this2 = this;

      console.log("[WsEvent] Initiating WS event manager...");
      // This code is a bit misleading. If a problem happens while setting up the Websocket,
      // then the catch handler here will fire. Most problems seem to occur after the Websocket
      // is setup and the handlers are attached so in most cases, I have seen problems connecting
      // to a socket get handled by the error handler.
      try {
        this.socket = new WebSocket(wsComponentEventHost + '/websocket/account/' + accountId + '/event/' + eventId + '/componentEvent/producer');
        this.socket.addEventListener('open', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  console.warn('[WsEvent] WS connection has been successfully established.');
                  // Connection is ready. Cleanup interval and process
                  // unprocessed events if there are any waiting on the queue.
                  _this2.checkConnectionCleanup();
                  _context2.next = 4;
                  return _this2.handleUnprocessedEvents();

                case 4:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        })));
        this.socket.addEventListener('message', this.event);
        this.socket.addEventListener('close', this.close);
        this.socket.addEventListener('error', this.error);
        return true;
      } catch (e) {
        var msg = '[WsEvent] Error initializing WebSocket: ';
        console.warn(msg, e);
        _RUMUtil2.default.addError(e);
      }
      return false;
    }

    /**
     * Will gracefully close the socket on a control room clean action
     */

  }, {
    key: 'send',
    value: function send(postObj) {
      dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Sending event: ' + postObj.params.componentEventId + '.');
      try {
        this.socket.send(JSON.stringify(postObj));
      } catch (err) {
        console.warn('[WsEvent] Error in postEvent: ', err);
        _RUMUtil2.default.addError(err);
      }
    }

    /*
      Called on an interval to see if connection status has changed.
      If MAX_CONNECTION_CHECKS has exceeded will evoke error handler
      to failover to HTTP.
    */

  }, {
    key: 'checkConnectionCleanup',


    /*
      Websocket connection has been fully established and we're ready to 
      send events through the websocket.  
      Need to clear up the interval.
    */
    value: function checkConnectionCleanup() {
      if (this.checkConnectionInterval) {
        clearInterval(this.checkConnectionInterval);
        this.checkConnectionInterval = null;
        this.numOfChecks = 0;
      }
    }
  }, {
    key: 'handleUnprocessedEvents',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.unprocessedEvents.size > 0)) {
                  _context3.next = 4;
                  break;
                }

                dmInstance.logMessage([_DebugManager2.default.debugLevel.WS], '[WSEvent] Begin processing unprocessed events via websocket.');
                _context3.next = 4;
                return this.processUnprocessedEvents();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleUnprocessedEvents() {
        return _ref6.apply(this, arguments);
      }

      return handleUnprocessedEvents;
    }()
  }, {
    key: 'generatePostData',
    value: function generatePostData(componentEventId, metadata, data, inBand) {
      var destinationType = metadata.destinationType,
          eventId = metadata.eventId,
          accountId = metadata.accountId;


      if ((0, _isUndefined2.default)(destinationType) || (0, _isUndefined2.default)(eventId) || (0, _isUndefined2.default)(accountId)) {
        console.error('[WsEvent] metadata missing! Unable to process event.', data);
        return;
      }

      var destination = destinationType === 'audience' ? 'viewer' : destinationType;
      return {
        eventId: eventId,
        accountId: accountId,
        action: 'postComponentEvent',
        params: {
          destination: destination.toUpperCase(),
          componentEventId: componentEventId,
          inBand: inBand
        },
        payload: JSON.parse(data)
      };
    }
    /*
      Process all events that were received prior to a fully
      established websocket connection.
    */

  }]);

  return WSEvent;
}();

exports.default = WSEvent;